// authGuard.ts
import { authStore } from "$lib/stores/authStore";
import { goto } from "$app/navigation";
import { routes } from "$lib/routes";
import { isDevelopment } from "$lib/utility/environment";
import { browser } from "$app/environment";

export function authenticate(currentPath?: string) {
  const currentState = authStore.getAuthState();
  logger.log("[AuthGuard] Checking auth:", currentState);

  if (currentState.isLoggedIn) {
    return;
  }

  const isAuthPage =
    browser && (window.location.pathname === routes.signIn || window.location.pathname === routes.signUp);

  if (isAuthPage) {
    return;
  }

  if (!currentState.signInIntent && currentPath && !isAuthPage) {
    logger.log("[AuthGuard] Setting sign in intent:", currentPath);
    authStore.setSignInIntent(currentPath);
  }

  goto(routes.signIn);
}

export function redirectIfNotAdmin(allowInDev: boolean = true) {
  if (allowInDev && isDevelopment()) {
    return;
  }
  if (!authStore.isAdmin()) {
    goto(routes.root);
  }
}

export function redirectIfSignedIn(path?: string) {
  if (authStore.isLoggedIn()) {
    const redirectPath = path || routes.root;
    goto(redirectPath);
  }
}
